module.exports = new __parcel__URL__("Meeting notes Hover.7ae587e9.svg").toString();